import type { MatterIntakeTemplateQuestion } from "@/lib/types";
import { z } from "zod";

// Dynamic form schema based on question type
export const createIntakeResponseSchema = (
  questions: MatterIntakeTemplateQuestion[],
) => {
  const schemaFields: Record<string, z.ZodTypeAny> = {
    templateId: z.string().min(1, "Template selection is required"),
  };

  questions.forEach((question) => {
    const fieldName = `question_${question.id}`;

    switch (question.type) {
      case "Multiple Choice":
        schemaFields[fieldName] = z.string().min(1, "This field is required");
        break;
      case "Checkbox":
        schemaFields[fieldName] = z.boolean().optional();
        break;
      case "Number":
        schemaFields[fieldName] = z.coerce.number().optional();
        break;
      case "Date":
        schemaFields[fieldName] = z.string().optional();
        break;
      case "Email":
        schemaFields[fieldName] = z.string().email("Invalid email").optional();
        break;
      case "Phone Number":
        schemaFields[fieldName] = z.string().optional();
        break;
      case "Address":
      case "Textarea":
        schemaFields[fieldName] = z.string().optional();
        break;
      case "File Upload":
        schemaFields[fieldName] = z.any().optional();
        break;
      default:
        schemaFields[fieldName] = z.string().optional();
    }
  });

  return z.object(schemaFields);
};

// Dynamic form schema for editing a single response
export const createEditIntakeResponseSchema = (questionType: string) => {
  switch (questionType) {
    case "Multiple Choice":
      return z.object({
        answer: z.string().min(1, "This field is required"),
      });
    case "Checkbox":
      return z.object({
        answer: z.boolean().optional(),
      });
    case "Number":
      return z.object({
        answer: z.coerce.number().optional(),
      });
    case "Date":
      return z.object({
        answer: z.string().optional(),
      });
    case "Email":
      return z.object({
        answer: z.string().email("Invalid email").optional(),
      });
    case "Phone Number":
      return z.object({
        answer: z.string().optional(),
      });
    case "Address":
    case "Textarea":
      return z.object({
        answer: z.string().optional(),
      });
    case "File Upload":
      return z.object({
        answer: z.any().optional(),
      });
    default:
      return z.object({
        answer: z.string().optional(),
      });
  }
};
